export default __webpack_public_path__ + "18e8cd8159fa4565b30ccc1013f88bf3.png";